import MetricsDistributionsWrapper from "components-for/metrics/metrics-distributions-wrapper";
import ResizeObserver from "resize-observer-polyfill";
import { faAnalytics } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FunctionComponent, memo, useState } from "react";
import { IProps } from "./select-metric-distributions.types";
import { NumericValue } from "@edgetier/client-components";
import { useField } from "formik";
import { useLayer } from "react-laag";
import "./select-metric-distributions.scss";

/**
 * Display a field to select metrics distributions range.
 * Only displayed after a metric is selected
 * @param props.metricType    Metric selected
 * @param props.label         Metric label
 */
const SelectMetricDistribution: FunctionComponent<IProps> = ({
    maximumFieldName,
    minimumFieldName,
    metricType,
    label,
}) => {
    const [maximumField] = useField(maximumFieldName);
    const [minimumField] = useField(minimumFieldName);

    const [isOpen, setIsOpen] = useState(false);
    const close = () => setIsOpen(false);
    const toggle = () => setIsOpen(!isOpen);

    const { renderLayer, triggerProps, layerProps } = useLayer({
        auto: true,
        isOpen,
        onOutsideClick: close,
        onParentClose: close,
        triggerOffset: 4,
        placement: "bottom-start",
        ResizeObserver,
    });

    const distributionDropdownStyles = {
        ...layerProps.style,
        zIndex: 500,
    };

    return (
        <>
            {renderLayer(
                isOpen && (
                    <div ref={layerProps.ref} style={distributionDropdownStyles}>
                        <MetricsDistributionsWrapper
                            maximumFieldName={maximumFieldName}
                            metricType={metricType}
                            minimumFieldName={minimumFieldName}
                            close={close}
                        />
                    </div>
                )
            )}

            <div className="field field-inline metrics-distributions" onClick={toggle} ref={triggerProps.ref}>
                <div className="metrics-distributions__field">
                    <div className="field-inline__icon">
                        <FontAwesomeIcon icon={faAnalytics} />
                    </div>
                    {typeof minimumField.value === "number" && typeof maximumField.value === "number" ? (
                        <div>
                            <NumericValue value={minimumField.value} /> &ndash;{" "}
                            <NumericValue value={maximumField.value} />
                        </div>
                    ) : (
                        <div className="metrics-distributions__field--empty">{label}&hellip;</div>
                    )}
                </div>
            </div>
        </>
    );
};

export default memo(SelectMetricDistribution);
